import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useAddEditIncidentTypeDialogHooks } from "./AddEditIncidentTypeDialog.hooks";
import { IncidentType } from "../incidentTypes/IncidentTypes.types";

export interface IAddEditIncidentTypeDialogProps {
    onDialogClose: () => void;
    isAdd: boolean;
    incidentTypeToUpdate: IncidentType | undefined;
    onSaved: () => void;
}

function AddEditIncidentTypeDialog(props: IAddEditIncidentTypeDialogProps) {
    const { translateString } = useTranslation();
    const { isSaving, onNameChange, onSave, saveModel, validation } = useAddEditIncidentTypeDialogHooks(props);

    return (
        <DotLegalDialog
            size="sm"
            inProgress={isSaving}
            header={props.isAdd ? translateString("createIncidentType") : translateString("editIncidentType")}
            buttonOkText={props.isAdd ? translateString("create") : translateString("save")}
            open
            onDialogClose={props.onDialogClose}
            onOkClick={onSave}
        >
            <DotLegalTextField
                label={translateString("name")}
                value={saveModel.name}
                debounce={false}
                errorText={validation.getErrorsForDisplay("name")}
                onChange={onNameChange}
            />
        </DotLegalDialog>
    );
}

export default AddEditIncidentTypeDialog;
